import React, { ReactNode } from "react";

import clsx from "clsx";

import { Button as MuiButton, ButtonProps, styled, css } from "@mui/material";

import { clsxm } from "@/utils/tailwindMerge";

type PropTypes = Omit<ButtonProps, "variant"> & {
  children: ReactNode;
  variant: "primary" | "secondary" | "rounded" | "text" | "icon";
  fakeButton?: boolean;
  ["data-testid"]?: string;
};

const StyledHtmlButton = styled("div")<Pick<ButtonProps, "size">>(() => {
  return css`
    text-transform: uppercase;
    text-align: center;

    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
  `;
});
/**@deprecated Use Button */
export const Old_Button: React.FC<PropTypes> = ({
  children,
  variant = "primary",
  className,
  fakeButton,
  startIcon,
  size,
  ...rest
}) => {
  const sharedProps: Pick<ButtonProps, "className" | "size"> = {
    className: clsxm(
      "whitespace-nowrap rounded-2xl font-primary text-base px-3 py-2 shadow font-bold",
      variant === "primary" && "text-white bg-gradient-green",
      variant === "secondary" && "text-green-600 bg-white",
      variant === "rounded" && "rounded-full p-0 min-w-0 w-8 h-8",
      variant === "text" &&
        "shadow-none p-0 min-w-0 text-grey1-900 normal-case font-normal",
      variant === "icon" && "min-w-0 rounded-full p-1 text-pink",
      size === "small" && "h-8 py-0",
      className,
    ),
    size,
  };

  if (fakeButton) {
    return (
      <StyledHtmlButton
        className={clsx(sharedProps.className, "text-grey1-900")}
        data-testid={rest["data-testid"]}
      >
        {startIcon}
        {children}
      </StyledHtmlButton>
    );
  }

  return (
    <MuiButton startIcon={startIcon} {...sharedProps} {...rest}>
      {children}
    </MuiButton>
  );
};
